function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) {
    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
    try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
            if (Object(_i) !== _i)
                return;
            _n = !1;
        }
        else
            for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0)
                ;
    }
    catch (err) {
        _d = !0, _e = err;
    }
    finally {
        try {
            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r))
                return;
        }
        finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
} }
function _arrayWithHoles(arr) { if (Array.isArray(arr))
    return arr; }
import { matchPath } from 'react-router-dom';
import { NAVIGATION_ITEM_TYPES } from './types';
/**
 * Parses a string permission (e.g. "user:read") into an object with `subject` and `action`.
 * @param permission - The permission string to parse.
 * @returns The parsed permission object.
 * @throws If the permission format is invalid.
 */
export var parsePermission = function parsePermission(permission) {
    if (!permission) {
        throw new Error('Permission string cannot be empty.');
    }
    var _permission$split = permission.split(':', 2), _permission$split2 = _slicedToArray(_permission$split, 2), subject = _permission$split2[0], action = _permission$split2[1];
    if (!subject || !action) {
        throw new Error("Invalid permission format: \"".concat(permission, "\". Expected \"subject:action\"."));
    }
    return {
        action: action,
        subject: subject
    };
};
/**
 * Determines whether a user has at least one of the permissions
 * @param ability
 * @param permissions
 */
export var hasAtLeastOnePermission = function hasAtLeastOnePermission(ability, permissions) {
    if (!permissions || permissions.length === 0) {
        return true;
    }
    return permissions.some(function (permission) {
        var _ability$can;
        var _parsePermission = parsePermission(permission), action = _parsePermission.action, subject = _parsePermission.subject;
        return !!((_ability$can = ability.can) !== null && _ability$can !== void 0 && _ability$can.call(ability, action, subject));
    });
};
/**
 * Checks if the current path matches any of the paths to compare.
 * @param currentPath The current path to check.
 * @param pathsToCompare The list of paths to compare.
 */
export var isNavigationItemActive = function isNavigationItemActive(_ref) {
    var _ref$currentPath = _ref.currentPath, currentPath = _ref$currentPath === void 0 ? '' : _ref$currentPath, _ref$pathsToCompare = _ref.pathsToCompare, pathsToCompare = _ref$pathsToCompare === void 0 ? [] : _ref$pathsToCompare;
    if (!pathsToCompare || pathsToCompare.length === 0) {
        return false;
    }
    return pathsToCompare.some(function (path) {
        return matchPath(currentPath, {
            path: path
        });
    });
};
/**
 * Filters items based on feature toggles and permissions.
 * @param navigationItems The list of navigation items to filter and map.
 * @param enabledFeatures The features object containing the state of feature toggles.
 */
export var filterVisibleItems = function filterVisibleItems(navigationItems, enabledFeatures, ability) {
    var filterByFeatureToggle = function filterByFeatureToggle(_ref2) {
        var allowedFeatureFlags = _ref2.allowedFeatureFlags;
        var hasAllowedFeature = !(allowedFeatureFlags !== null && allowedFeatureFlags !== void 0 && allowedFeatureFlags.length) || allowedFeatureFlags.some(function (featureFlag) {
            return !!(enabledFeatures !== null && enabledFeatures !== void 0 && enabledFeatures[featureFlag]);
        });
        return hasAllowedFeature;
    };
    return navigationItems.filter(filterByFeatureToggle).filter(function (item) {
        return hasAtLeastOnePermission(ability, item.permissions);
    }).map(function (item) {
        if (item.type === NAVIGATION_ITEM_TYPES.menu) {
            return _objectSpread(_objectSpread({}, item), {}, {
                items: item.items.filter(function (_ref3) {
                    var permissions = _ref3.permissions;
                    return hasAtLeastOnePermission(ability, permissions);
                })
            });
        }
        return item;
    });
};
